/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Retry_FailedInputs */

const en_course_retry_failed = /** @type {(inputs: Course_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry failed`)
};

const ja_course_retry_failed = /** @type {(inputs: Course_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行に失敗しました`)
};

const fr_course_retry_failed = /** @type {(inputs: Course_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la nouvelle tentative`)
};

const de_course_retry_failed = /** @type {(inputs: Course_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Retry failed" |
*
* @param {Course_Retry_FailedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_retry_failed = /** @type {((inputs?: Course_Retry_FailedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Retry_FailedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_retry_failed(inputs)
	if (locale === "ja") return ja_course_retry_failed(inputs)
	if (locale === "fr") return fr_course_retry_failed(inputs)
	return de_course_retry_failed(inputs)
});